import { render, staticRenderFns } from "./DetailChartPanel.vue?vue&type=template&id=af04f7f6&scoped=true&"
import script from "./DetailChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailChartPanel.vue?vue&type=style&index=0&id=af04f7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af04f7f6",
  null
  
)

export default component.exports